var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_15123_119249)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0798 14.5956C16.9259 14.5189 16.7563 14.479 16.5843 14.479C16.4123 14.479 16.2427 14.5189 16.0887 14.5956C15.4785 14.9153 14.7999 15.0823 14.111 15.0823C13.4221 15.0823 12.7435 14.9153 12.1333 14.5956C11.9793 14.5189 11.8097 14.479 11.6377 14.479C11.4657 14.479 11.2961 14.5189 11.1422 14.5956C10.502 14.9054 9.96179 15.3888 9.58304 15.9907C9.20429 16.5926 9.00227 17.2888 9 18V18.8889C9 19.1836 9.11706 19.4662 9.32543 19.6745C9.5338 19.8829 9.81641 20 10.1111 20H18.1109C18.4056 20 18.6882 19.8829 18.8966 19.6745C19.105 19.4662 19.222 19.1836 19.222 18.8889V18C19.2197 17.2888 19.0177 16.5926 18.639 15.9907C18.2602 15.3888 17.72 14.9054 17.0798 14.5956Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1115 13.7777C15.7069 13.7777 17.0003 12.4843 17.0003 10.8888C17.0003 9.29337 15.7069 8 14.1115 8C12.516 8 11.2227 9.29337 11.2227 10.8888C11.2227 12.4843 12.516 13.7777 14.1115 13.7777Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15123_119249",
    x1: 34.2332,
    y1: 21.7668,
    x2: 21.7668,
    y2: -6.23321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055BDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CAC93"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/Account_Icon.12d8e562b6d4892cc9e21a1d4d0f02ed.svg";
export { ForwardRef as ReactComponent };